import { get } from '.';

export function FindConferenceCallCallQueue(conferenceVid, options = {}) {
	return get<any>("/app/api/conferences/" + conferenceVid + "/call_call_queue", options);
}
